import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';

const STORAGE_KEY_BEGIN_DATE = '@my-security/service-orders/begin-date';
const STORAGE_KEY_END_DATE = '@my-security/service-orders/end-date';

function useActionsParams() {
  const beginDateDefault = dayjs().startOf('month').toISOString();
  const endDateDefault = dayjs().endOf('month').toISOString();

  const beginDateStorage = sessionStorage.getItem(STORAGE_KEY_BEGIN_DATE);
  const endDateStorage = sessionStorage.getItem(STORAGE_KEY_END_DATE);

  const [searchParams, setSearchParams] = useSearchParams();
  const beginDate = searchParams.get('beginDate') || beginDateStorage || beginDateDefault;

  const endDate = searchParams.get('endDate') || endDateStorage || endDateDefault;

  function setDates(newBeginDate: string, newEndDate: string) {
    sessionStorage.setItem(STORAGE_KEY_BEGIN_DATE, newBeginDate);
    sessionStorage.setItem(STORAGE_KEY_END_DATE, newEndDate);
    setSearchParams({ beginDate: newBeginDate, endDate: newEndDate });
  }
  return {
    beginDate,
    endDate,
    setDates,
  };
}

export default useActionsParams;
